import {uuid} from "../utils";

export default function Websocket (){
    this.mark = "websocket_";
    this.msgHanderList = [];
};

Websocket.prototype.addHandler = function(handler){
    if(!BaseHandler.prototype.isPrototypeOf(handler)){
        console.log(`无法加入websocket消息处理器, handler不是BaseHandler的子类!`);
    }else{
        this.msgHanderList.push(handler);
        this.msgHanderList.sort((handler1, handler2)=>{
            return handler1.order() - handler2.order();
        });
    }
};

Websocket.prototype.isStart = function(){
    return false;//这里以前是用的sessionStorage的值来判断是否已经建立过了，目前不需要这样了，只需要给后端传uuid_key参数就能保证只被创建一次
};

Websocket.prototype.close = function(){
    if(this.ws && this.ws.close){
        this.ws.close(1000);
    }
};

Websocket.prototype.send = function(data){
    this.ws.send(JSON.stringify(data));
};

Websocket.prototype.start = function (userId) {
    let _that = this;
    let isStart = this.isStart();
    if(isStart){//如果启动过了就不启动了
        return;
    }
    // 如果当前的是https 的时候，换成 wss ,否则是ws
    let wsHead='ws';
    if(window.location.protocol=='https:'){
        wsHead='wss'
    }
    this.ws = new WebSocket(wsHead+`://${window.location.host}/cm-sites-websocket/connectWebSocket/${userId}/${userId}_${uuid()}`);
    console.log("this.ws:  ", this.ws);
    this.ws.onopen = function(event){
        heartCheck.reset().start();   // 成功建立连接后，重置心跳检测
        _that.onopen && _that.onopen();
    };

    //连接发生错误的回调方法
    this.ws.onerror = function(){
        _that.onerror && _that.onerror();
    };

    //连接关闭的回调方法
    this.ws.onclose = function(){
        _that.onclose && _that.onclose();
    };

    //接收到消息的回调方法
    this.ws.onmessage = function(event){
        console.log('--WS---',event)
        let msg = event.data;
        for(let i = 0; _that.msgHanderList && i < _that.msgHanderList.length; i++){
            let handler = _that.msgHanderList[i];
            if(msg){
                if(typeof handler.isSupport === "function" && typeof handler.handle === "function"){
                    if(handler.isSupport(msg)){
                        handler.handle(msg);
                        break;
                    }
                }
            }
        }
    };


    // 心跳检测, 每隔一段时间检测连接状态，如果处于连接中，就向server端主动发送消息，来重置server端与客户端的最大连接时间，如果已经断开了，发起重连。
    let heartCheck = {
        timeout: 20 * 1000,        // 20秒发一次心跳，比server端设置的连接时间稍微小一点，在接近断开的情况下以通信的方式去重置连接时间。
        serverTimeoutObj: null,
        reset: function(){
            clearInterval(this.serverTimeoutObj);
            return this;
        },
        start: function(){
            this.serverTimeoutObj = setInterval(function(){
                if(_that.ws.readyState == 1){
                    console.log("连接状态，发送消息保持连接");
                    _that.ws.send(JSON.stringify({ping:1}));
                }else{
                    console.log("断开状态，尝试重连");
                    heartCheck.reset();//.start();    // 如果获取到消息，说明连接是正常的，重置心跳检测
                    _that.start(userId);
                }
            }, this.timeout)
        }
    };
};


export class BaseHandler{

    static ORDER_HIGHT = -1000;
    static ORDER_LOW = 1000;
    static ORDER_DEFAULT = 0;

    constructor(){
        if(!this.isSupport){
            console.error("消息处理器初始化失败！请实现isSupport方法")
        }
        if(!this.handle){
            console.error("消息处理器初始化失败！请实现handle方法")
        }
    }

    order(){
        return BaseHandler.ORDER_DEFAULT;
    }
}